(function($){
  var $doc = $(document);
  var $win = $(window);

  $win.on('load', function() {
    // init controller
    var controller = new ScrollMagic.Controller({
      globalSceneOptions: {
        //duration: 100%,
        //triggerHook: 0,
      }
    });
    var slides = $(".story-section");
    var durat = [];
    slides.each(function() {
      var h = $(this).height();
      durat.push(h);
    });
    slides.each(function(index) {
      var slide = $(this);
      var class_name = "";
      new ScrollMagic.Scene({
        triggerElement: slides.get(index),
        duration: durat[index],
        offset: 0
      })
      .setClassToggle(slide, 'active')
      .on('start', function(){
        slide.toggleClass('prev-active');
      })
      .addTo(controller)
      //.addIndicators();
    });
  });

  $win.scroll(function(){
    line_fill();
  });

  var $path;
  var path_start = 0;

  $doc.ready(function(){
    $path = $('.middle-path');
    if($path.length){
      path_start = $path.offset().top;
    }
    line_fill();
  });

  function line_fill(){
    var window_height = $win.height();
    var scroll_position = $win.scrollTop();
    if($path && $path.length){
      var progress_bar = $path.find('.progress-bar');
      var path_height = $path.height();
      var progress = (scroll_position - path_start) + (window_height / 2);
      var percentage = (progress / path_height) * 100.0;
      var clamped = Math.max(0, percentage);
      var clamped = Math.min(100, percentage);
      //console.log(clamped);
      progress_bar.css('height', clamped + '%');
    }
  }
})(jQuery);